import type { VoidFunctionComponent } from 'react';
import { Dropdown as BSDropdown, MenuItem } from 'react-bootstrap';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../generic/Button';
import Icon, { icons } from '../generic/Icon';
import { openInNewTab } from '../../utils';

//  Function which opens the export URL in a new tab.
//  This causes the browser to download the file and refocus the current tab.
const onExportPolicy = (policyId: number, fileType: 'csv' | 'json') =>
  openInNewTab(`/api/policies/${policyId}/export?fileType=${fileType}`);

type Props = {
  policyId: number;
};

/**
 * EditPolicyExportLicensingPolicyButton is the dropdown button allowing users to export
 * a licensing policy as a CSV or JSON file.
 */
const EditPolicyExportLicensingPolicyButton: VoidFunctionComponent<Props> = ({ policyId }) => (
  //  The additional padding helps vertically align the button with the page heading breadcrumbs.
  <div className="padding-bottom-sm">
    <BSDropdown
      id="export-licensing-policy-btn"
      onSelect={(fileType: 'csv' | 'json') => onExportPolicy(policyId, fileType)}
    >
      <Button
        bsRole="toggle"
        type={BUTTON_TYPE.PRIMARY}
        size={BUTTON_SIZE.MEDIUM}
        icon={icons.fileExport}
      >
        Export policy as... <Icon icon={icons.caretDown} />
      </Button>
      <BSDropdown.Menu>
        <MenuItem eventKey="json">JSON</MenuItem>
        <MenuItem eventKey="csv">CSV</MenuItem>
      </BSDropdown.Menu>
    </BSDropdown>
  </div>
);

export default EditPolicyExportLicensingPolicyButton;
